import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/type`
const resourceCRM = `${Repository.defaults.baseURL}`
export default {
    async list(params) {
        const response = await Repository.get(`${resource}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async listSegmentCodeApi(params) {
        const response = await Repository.get(`${resourceCRM}/fg/list?obj=segments&attrs[]=id&attrs[]=segmentCode`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createSegmentApi(data) {
        const response = await Repository.post(`${resourceCRM}/fg/set`,data, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async countSegment(params) {
        const response = await Repository.get(`${resourceCRM}/fg/count?obj=segments`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response;
    }
}